import React, { useState } from 'react'
import { Box, Dialog } from '@material-ui/core'
import { Loader } from './Loader'

type Props = {
  isLoading: boolean
}

export function LoadingDialog({ isLoading }: Props): React.ReactElement {
  const [open, setOpen] = useState(isLoading)

  return (
    <Dialog
      open={isLoading}
      onClose={(event, reason) => {
        if (reason && reason !== 'backdropClick') setOpen(false)
      }}
    >
      <Box p={5}>
        <Loader />
      </Box>
    </Dialog>
  )
}
